import { KebabMenuItemButton } from '@library/components/menus/kebabMenu/KebabMenuItemButton';
import { Menu } from '@headlessui/react';
import { classNames } from '@library/utils';

export interface KebabMenuItemProps {
  className?: string;
  children: React.ReactNode;
  disabled?: boolean;
  itemActiveClassName?: string;
  itemInactiveClassName?: string;
  handleOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const KebabMenuItem = ({
  className = '',
  children,
  disabled = false,
  handleOnClick,
  itemActiveClassName = '',
  itemInactiveClassName = ''
}: KebabMenuItemProps) => {
  return (
    <Menu.Item>
      {({ active }) => {
        const menuItemClassName = classNames(
          active ? itemActiveClassName : itemInactiveClassName,
          className
        );
        return (
          <KebabMenuItemButton
            className={menuItemClassName}
            disabled={disabled}
            handleOnClick={handleOnClick}
          >
            {children}
          </KebabMenuItemButton>
        );
      }}
    </Menu.Item>
  );
};
